import "normalize.css";
// import "amfe-flexible";
import "@/utils/font-size";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters";
import ajax from "./utils/ajax";

import Vant from "vant";
import "vant/lib/index.css";
// import Vconsole from "vconsole";

// let vConsole = new Vconsole();

// export default vConsole;
Vue.use(Vant);

Vue.prototype.$axios = ajax;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
